import { merge } from "lodash/fp";
import { HubThemePartial } from "../../types";
import xdiThemeBase from "./_base";

const xdiTheme = merge(xdiThemeBase, {} as HubThemePartial);

export default xdiTheme;
